const pages = {
  //Dashboard Module

  signIn: {
    ID: "sign-in",
    route: "/sign-in",
  },

  signUp: {
    ID: "sign-up",
    route: "/sign-up",
  },

  analytics: {
    ID: "analytics",
    route: "/analytics/",
  },

  home: {
    ID: "home",
    route: "/",
  },

  verifyAccount: {
    ID: "verify-account",
    route: "/verify/",
  },

  brandDetailCreateEmpty: {
    ID: "create-brand-empty",
    route: "/create-brand-details",
  },

  brandDetailEmpty: {
    ID: "create-brand-empty-details",
    route: "/brand/create",
  },

  brandDetails: {
    ID: "brand-details",
    route: "/brand/details",
  },

  companyDetails: {
    ID: "company-details",
    route: "/company/details",
  },

  companyDetailsCreateEmpty: {
    ID: "company-details-create-empty",
    route: "/company/create",
  },

  companyDetailsEmpty: {
    ID: "company-details-empty",
    route: "/company/detail",
  },

  agencyBrandsPage: {
    ID: "brands-agency",
    route: "/brand/all",
  },

  campaignRequest: {
    ID: "dp-campaign",
    route: "/campaigns",
  },

  myCampaign: {
    ID: "my-campaign",
    route: "/campaign/all",
  },

  createCampaign: {
    ID: "create-campaign",
    route: "/campaign/create",
  },

  campaignDetails: {
    ID: "campaign-details",
    route: "/campaign/",
  },

  campaignRequestDetails: {
    ID: "campaign-request-details",
    route: "/campaign-request-details/",
  },

  campaignAccepted: {
    ID: "campaign-accepted",
    route: "/campaign-accepted",
  },

  campaignAcceptedDetails: {
    ID: "campaign-accepted-details",
    route: "/campaign-accepted-details/",
  },

  audienceList: {
    ID: "audience-list",
    route: "/audience/all",
  },

  createAudience: {
    ID: "create-audience",
    route: "/audience/create",
  },

  superadminAudienceList: {
    ID: "superadmin-audience-list",
    route: "/superadmin/audience/all",
  },

  audienceDetails: {
    ID: "audience-details",
    route: "/audience/",
  },

  exploreConnections: {
    ID: "explore-connections",
    route: "/my-connections",
  },

  connectionDetails: {
    ID: "connection-details",
    route: "/connection-details/",
  },

  welcomePage: {
    ID: "welcome-page",
    route: "/landing-page",
  },

  createWelcomePage: {
    ID: "create-welcome-page",
    route: "/setup-brand-page",
  },

  adminWelcomePage: {
    ID: "admin-welcome-page",
    route: "/admin-landing-page",
  },

  channelAgentSettingPage: {
    ID: "channel-setting-page",
    route: "/channel-setting-page",
  },

  createTemplate: {
    ID: "create-template",
    route: "/create-template",
  },

  templateList: {
    ID: "template-list",
    route: "/template-list",
  },

  templateDetails: {
    ID: "template-details",
    route: "/template-details/",
  },

  creditPage: {
    ID: "credit-page",
    route: "/credit-page",
  },

  profilePage: {
    ID: "profile-page",
    route: "/profile-page",
  },

  leadCampaign: {
    ID: "lead-campaign-page",
    route: "/lead-campaign",
  },

  detailsLeadCampaign: {
    ID: "lead-campaign-page",
    route: "/lead-campaign/",
  },

  listLeadCampaign: {
    ID: "lead-campaign-list-page",
    route: "/lead-campaign/all",
  },

  apiLeadCampaignDetails: {
    ID: "lead-campaign-api-page",
    route: "/lead-campaign/api-details/",
  },

  // super admin pages

  brandsList: {
    ID: "administrator-brands",
    route: "/brands",
  },

  usersList: {
    ID: "users-list",
    route: "/users/",
  },

  accountVerification: {
    ID: "verify-account",
    route: "/accounts-verification",
  },

  createUser: {
    ID: "create-user",
    route: "/create-user",
  },

  adminCampaignRequest: {
    ID: "campaign-request-admin",
    route: "/campaigns/admin/request",
  },

  userDetails: {
    ID: "user-details",
    route: "/user-details/",
  },

  superAdminBrandCampaigns: {
    ID: "brand-campaigns",
    route: "/campaign/brand/",
  },

  addCampaignStats: {
    ID: "add-campaign-stats",
    route: "/campaign/add/stats/",
  },

  superAdminCampaignDetails: {
    ID: "brand-campaign-details",
    route: "/campaign/details/",
  },

  superAdminAllCampaigns: {
    ID: "all-campaign",
    route: "/admin/campaign/all",
  },

  dpOnBoardingList: {
    ID: "all-boarding",
    route: "/on-boarded-connections",
  },

  dpOnBoarding: {
    ID: "dp-on-boarding",
    route: "/dp-on-boarding",
  },

  dpOnBoardingDetails: {
    ID: "dp-on-boarding",
    route: "/dp-on-boarding-details/",
  },

  changePassword: {
    ID: "change-password",
    route: "/change-password",
  },

  resetEmailPasswordPage: {
    ID: "reset-email-password",
    route: "/reset-password",
  },

  forgotPasswordPage: {
    ID: "forgot-password",
    route: "/forgot-password/",
  },

  unverifiedAgenciesList: {
    ID: "unverified-agencies-list",
    route: "/superadmin-agencies-list",
  },

  unverifiedAgenciesDetails: {
    ID: "unverified-agencies-details",
    route: "/superadmin-agencies-details",
  },

  unverifiedCompanyAgencyDetails: {
    ID: "unverified-agencies-details",
    route: "/superadmin-agency-company-details",
  },

  unverifiedPage: {
    ID: "unverified-brand-list",
    route: "/superadmin-brand-list",
  },

  unverifiedPageDetails: {
    ID: "unverified-brand-details",
    route: "/superadmin-brand-details",
  },

  unverifiedCompanyDetails: {
    ID: "unverified-company-details",
    route: "/superadmin-company-details",
  },

  permissionSettingsPage: {
    ID: "permission-settings",
    route: "/permission-settings",
  },

  dynamicUiPageDetails: {
    ID: "site-settings",
    route: "/platform-tenants",
  },

  dynamicUiListPage: {
    ID: "site-settings",
    route: "/platform-tenants/all",
  },

  groupListPage: {
    ID: "group-list-page",
    route: "/groups/all",
  },

  groupCreatePage: {
    ID: "group-create-page",
    route: "/group-create",
  },

  groupDetailsPage: {
    ID: "group-details-page",
    route: "/group-details/",
  },

  customFieldsListPage: {
    ID: "custom-field-list-page",
    route: "/audience-custom-fields/all",
  },

  customFieldsCreatePage: {
    ID: "custom-field-create-page",
    route: "/create-audience-custom-field",
  },

  customFieldsDetailsPage: {
    ID: "custom-field-details-page",
    route: "/audience-custom-field-details/",
  },

  //AGENCY

  welcomeAsAgencyPage: {
    ID: "welcome-agency",
    route: "/welcome-agency",
  },

  createAgencyPage: {
    ID: "create-agency",
    route: "/create-agency",
  },

  agencyDetailsEmptyPage: {
    ID: "agency-details-empty",
    route: "/agency-details",
  },

  agencyEmptyDetailBrandPage: {
    ID: "agency-brand-details-empty",
    route: "/agency-brand-details",
  },

  agencyDashboardDetailPage: {
    ID: "agency-dashboard-details",
    route: "/agency-details-dashboard",
  },

  platformsTenantsList: {
    ID: "agency-tenants-list",
    route: "/platforms/tenants/all",
  },

  //misc
  permissionDenied: {
    ID: "permission",
    route: "/permission-denied",
  },

  whatsAppOnboardingPage: {
    ID: "whatsapp-onboarding",
    route: "/whatsapp-onboarding",
  },

  createOnboardLink: {
    ID: "createOnboardLink",
    route: "/create-onboard-link/",
  },

  botDetailsPage: {
    ID: "botDetailsPage",
    route: "/bot-details/",
  },
};

export default pages;
